import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import * as maptilersdk from '@maptiler/sdk'
import Lock from '@mui/icons-material/Lock'
import LockOpen from '@mui/icons-material/LockOpen'
import { markerCreateRequest, markerThreeDUpdateRequest } from '../../../../action/marker-actions'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { dateConvertion } from '../../../main-ui/common/commonfunctions'
import { store } from '../../../../lib/store'
import { expandLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import {
  buildMarkerTemplate, MakeTextInput, NewMarkerIconStyle, GetHeader,
  // buildPhotoPopover
} from './addHandlers';
import { buildContent } from '../../../main-ui/left-toolbar/common/marker-details';

let globalMapObject = null

// 🔴 Main popover builder
function buildPhotoPopover(PopoverElement, markerObj, i, props, interactiveMarker) {
  const popover = new PopoverElement();
  // popover.setAttribute("popover", "manual");
  popover.hide = () => { popover.style.display = "none"; };
  popover.style.display = "block";

  let colorMarker
  if (markerObj) {
    let color = markerObj.color
    let url = markerObj.markerType.vectorIconUrl
    const hasSpaces = url.includes(' ');
    if (color) {
      if (color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color;
      } else {
        colorMarker = color[0] == '#' ? color : '#' + color.substring(color.length == 7 ? 1 : 2);
      }
    } else {
      colorMarker = '#9ecc3b';
    }
  }

  let removeMarker = () => { }

  // === Main Container ===
  const container = document.createElement("div");
  container.style.padding = "10px";
  container.style.height = "165px";
  container.style.width = "300px";
  container.style.backgroundColor = "#1d1d1d";
  container.style.visibility = "visible";
  container.style.borderRadius = "10px";

  // --- Header Section ---
  const headerContainer = document.createElement("div");
  headerContainer.className = "info-window-header-container";

  const headerLeft = document.createElement("div");
  headerLeft.id = "my-react-component-container";
  headerLeft.style.width = "90%";

  const headerDiv = document.createElement("div");
  headerDiv.className = "info-window-header-div";

  const heading = document.createElement("span");
  heading.className = "info-window-heading";
  heading.innerText = `${markerObj?.name}`;

  headerDiv.appendChild(heading);
  headerLeft.appendChild(headerDiv);

  const closeDiv = document.createElement("div");
  closeDiv.className = "info-window-closeicon";

  const closeLink = document.createElement("a");
  closeLink.id = "close";

  const closeImg = document.createElement("img");
  closeImg.src = "/asset/close.png";
  closeImg.alt = "Close";
  closeImg.style.width = "20px";
  closeImg.style.objectFit = "cover";
  closeImg.style.float = "right";
  closeImg.style.marginTop = "-10px";

  closeLink.appendChild(closeImg);
  closeDiv.appendChild(closeLink);

  headerContainer.appendChild(headerLeft);
  headerContainer.appendChild(closeDiv);

  // --- Info Section ---
  const infoWrapper = document.createElement("div");
  infoWrapper.style.width = "100%";
  infoWrapper.style.display = "flex";
  infoWrapper.style.position = "relative";
  infoWrapper.style.zIndex = "111";
  infoWrapper.style.justifyContent = "center";

  const infoLeft = document.createElement("div");
  infoLeft.style.width = "90%";



  const reduxState = store.getState();
  const { userPreferences } = reduxState;

  const formattedDate = dateConvertion(markerObj?.created)
  let altitudeValue = userPreferences.units == 'imperial' ? (markerObj?.altitude * 3.28084).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'ft' : markerObj?.altitude.toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'm';

  let onButtonClick = (markerObj) => {
    if (popover) {
      popover.open = false;  // ← the correct close method
    }
    setTimeout(() => {
      store.dispatch(expandLeftToolbar({
        dialog: 'edit', editable: markerObj, mapObj: globalMapObject
      }));
    }, 200);
  };

  infoLeft.innerHTML = `
  <div style="width: 100%; display: flex; position: relative; z-index: 111;">                
          <div style="width: 70%; ">
                <h6 class="info-box-head-date">Created : <span class="info-box-head-date">${formattedDate || "N/A"}</span></h6>
                <h6 class="info-box-head">Elev : <span class="info-box-span">${altitudeValue || "N/A"}</span></h6>
                <h6 class="info-box-head">Latitude : <span class="info-box-span">${markerObj?.latitude}</span></h6>
                <h6 class="info-box-head">Longitude : <span class="info-box-span">${markerObj?.longitude}</span></h6>
              <div style="width:100%; display:flex; margin-top:10px; margin-right:10px;justify-content: space-evenly;">
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <a id="shareButton">
                          <div class="info-window-bottons">
                            <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/shared.png">
                          </div>
                        </a>
                      <p style="height: 15px;font-size:10px">Share</p>
                  </div>
                 
                <!--  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="deleteButtonThreed">
                        <div class="info-window-bottons">
                          <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/bin.png">
                        </div>
                      </a>                    
                      <p style="height: 15px;font-size:10px">Delete</p>
                  </div>  -->

                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="editButtonThreed">
                        <div class="info-window-bottons">
                          <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/pencil.png">
                        </div>
                      </a>                    
                      <p style="height: 15px;font-size:10px">Edit</p>
                  </div> 

              </div>                
          </div>     
          
          
          <div style="width: 30%; display: flex; justify-content: center; ">        
              <svg class="info-marker-default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Define the clipping path for the circle -->
                  <defs>
                      <clipPath id="circleClip">
                          <circle cx="8" cy="6" r="5" />
                      </clipPath>
                  </defs>
                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path
                      d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                      fill='${colorMarker || ' #ffffff'}'></path>
                  <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
                  <!-- Image inside the circle with clipping path -->
                  <image xlink:href=${markerObj?.markerType.vectorIconUrl ? markerObj?.markerType.vectorIconUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5"
                          width="8" height="8" clip-path="url(#circleClip)"></image>
              </svg>
          </div>    

  </div> 
  `

  infoWrapper.appendChild(infoLeft);


  // Hook edit button
  const editBtn = infoLeft.querySelector("#editButtonThreed");
  if (editBtn) {
    editBtn.addEventListener("click", () => {
      onButtonClick(markerObj);
    });
  }

  let shareButton = infoLeft.querySelector("#shareButton")
  if (shareButton) {
    shareButton.addEventListener("click", () => {
      // latitude, longitude, markerName, markerDetails
      handleShareButton(markerObj.latitude, markerObj.longitude, markerObj.markerName, markerObj);
    });
  }


  // Hook delete button
  const deleteBtn = infoLeft.querySelector("#deleteButtonThreed");
  if (deleteBtn) {
    deleteBtn.addEventListener("click", () => {
      removeMarker()
    });
  }


  // 🔗 close event
  closeLink.addEventListener("click", () => {

    popover.removeAttribute("open");

  });

  // === Assemble popup ===
  container.appendChild(headerContainer);
  container.appendChild(infoWrapper);
  // container.appendChild(triangleContainer);

  popover.appendChild(container);

  (function () {
    const origAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      const shadow = origAttachShadow.call(this, init);
      if (this.tagName.toLowerCase() === "gmp-popover") {
        const style = document.createElement("style");
        style.textContent = `
        dialog {
          background-color: #1d1d1d !important;
          border-radius: 10px;
        }

        dialog:after {
         background-color: #1d1d1d !important;
        }
      `;
        shadow.appendChild(style);
      }
      return shadow;
    };
  })();

  return popover;
}

const round6 = v => Math.round(v * 1e6) / 1e6

const ThreeDMarkerDetails = (props) => {
  const [state, setState] = useState({ latitude: '', longitude: '', name: props.leftToolbarState?.editable?.name ? props.leftToolbarState.editable.name : `Marker - ${props.markers.length}`, notes: '' })
  const [openStyleIcon, setOpenStyleIcon] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState("Recent");
  const [filterItems, setFilterItems] = useState(null);
  const [colorMarker, setColorMarker] = useState("9ECC3B");
  const [markerTypeId, setMarkerTypeId] = useState(props?.usageFlag ? 88 : 134);
  const [locationName, setLocationName] = useState("Location");
  const [iconUrl, setIconUrl] = useState("https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg")
  const [markerType, setmarkerType] = useState(props?.markerGroups[0]?.markerType[0])
  const [loadSpinner, setLoadSpinner] = useState(false)
  let { editable } = props.leftToolbarState
  const isEditing = !!editable
  // Locked when editing (user must click Lock to move); unlocked immediately for new markers
  const [locationSet, setLocationSet] = useState(isEditing)
  const locationSetRef = useRef(isEditing)

  let markerRef = useRef(null)
  const iconUrlRef = useRef("https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg")
  const mouseMoveHandlerRef = useRef(null)
  const clickHandlerRef = useRef(null)

  // Matches 2D addMouseHandlers: cursor → crosshair, marker follows mouse, click → place + relock
  const startMoveMode = () => {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return
    setLocationSet(false)
    locationSetRef.current = false
    map.getCanvas().style.cursor = 'crosshair'

    if (mouseMoveHandlerRef.current) map.off('mousemove', mouseMoveHandlerRef.current)
    if (clickHandlerRef.current) map.off('click', clickHandlerRef.current)

    const onMove = (e) => {
      if (!e.lngLat) return
      const { lat, lng } = e.lngLat
      if (markerRef.current) markerRef.current.setLngLat([lng, lat])
      setState(prev => ({ ...prev, latitude: String(round6(lat)), longitude: String(round6(lng)) }))
    }
    const onClick = (e) => {
      const { lat, lng } = e.lngLat
      if (markerRef.current) markerRef.current.setLngLat([lng, lat])
      setState(prev => ({ ...prev, latitude: String(round6(lat)), longitude: String(round6(lng)) }))
      stopMoveMode()
    }
    map.on('mousemove', onMove)
    map.once('click', onClick)
    mouseMoveHandlerRef.current = onMove
    clickHandlerRef.current = onClick
  }

  // Matches 2D removeMouseHandlers: cursor restored, listeners removed, marker relocked
  const stopMoveMode = () => {
    const map = props.mapReferenceThreed
    setLocationSet(true)
    locationSetRef.current = true
    if (!map || typeof map.getCanvas !== 'function') return
    map.getCanvas().style.cursor = ''
    if (mouseMoveHandlerRef.current) { map.off('mousemove', mouseMoveHandlerRef.current); mouseMoveHandlerRef.current = null }
    if (clickHandlerRef.current)    { map.off('click',     clickHandlerRef.current);    clickHandlerRef.current = null }
  }

  useEffect(() => {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return

    if (props.leftToolbarState.editable) {
      setState({
        latitude: String(editable.latitude ?? ''), longitude: String(editable.longitude ?? ''), name: editable.name, notes: editable.notes
      })
      let colorValue = editable?.color || ''
      if (colorValue.startsWith('#')) colorValue = colorValue.substring(1)
      if (colorValue.length >= 8) colorValue = colorValue.substring(2)
      setColorMarker(colorValue)
      setLocationName(editable.markerType.name)
      setMarkerTypeId(editable.markerTypeId)
      setmarkerType(editable.markerType)
      iconUrlRef.current = editable.markerType.vectorIconUrl
      setIconUrl(editable.markerType.vectorIconUrl)
      mapFunction(editable.color, editable.markerTypeId, editable.latitude, editable.longitude)
      // Edit mode: start locked — user clicks Lock to enter move mode
    } else {
      mapFunction()
      // New marker: immediately enter move mode (matches 2D behaviour)
      startMoveMode()
    }

    return () => {
      if (mouseMoveHandlerRef.current) { map.off('mousemove', mouseMoveHandlerRef.current); mouseMoveHandlerRef.current = null }
      if (clickHandlerRef.current)    { map.off('click',     clickHandlerRef.current);    clickHandlerRef.current = null }
      map.getCanvas().style.cursor = ''
      if (markerRef.current) { markerRef.current.remove(); markerRef.current = null }
    }
  }, [props.mapReferenceThreed]);

  function mapFunction(color, svgId = 134, lat, lng) {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return

    if (markerRef.current) {
      markerRef.current.remove()
      markerRef.current = null
    }

    const center = map.getCenter()
    const markerLat = lat ?? center.lat
    const markerLng = lng ?? center.lng
    let hexColor = color ? (color.startsWith('#') ? color : '#' + color) : '#9ecc3b'
    if (hexColor.length > 7) hexColor = '#' + hexColor.slice(-6)

    const currentIconUrl = iconUrlRef.current || 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'

    const el = document.createElement('div')
    el.style.cursor = 'move'
    el.innerHTML = `<svg viewBox="0 0 16 16" width="35" height="35" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <clipPath id="place-marker-clip">
          <circle cx="8" cy="6" r="5" />
        </clipPath>
      </defs>
      <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z" fill="${hexColor}"/>
      <circle cx="8" cy="6" r="5" fill="white"/>
      <image href="${currentIconUrl}" xlink:href="${currentIconUrl}" x="4" y="1.5" width="8" height="8" clip-path="url(#place-marker-clip)"/>
    </svg>`

    const marker = new maptilersdk.Marker({ element: el, draggable: false, anchor: 'bottom', pitchAlignment: 'viewport', rotationAlignment: 'viewport' })
      .setLngLat([markerLng, markerLat])
      .addTo(map)

    markerRef.current = marker
    setState(prev => ({ ...prev, latitude: String(round6(markerLat)), longitude: String(round6(markerLng)) }))
  }


  let rebuild = (color, svgId) => {
    mapFunction(color, svgId, state.latitude, state.longitude)
  }

  let rebuildEdit = (color, svgId, lat, lng) => {
    mapFunction(color, svgId, lat, lng)
  }

  const handleInputChange = (field, value) => {
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const saveMarker = async () => {
    let { editable } = props.leftToolbarState

    let toSave = {
      altitude: 0,
      name: state.name,
      notes: state.notes,
      latitude: state.latitude,
      longitude: state.longitude,
      userId: props.user.id,
      markerTypeId: markerTypeId,
      color: colorMarker,
      markerType: {
        iconUrl: markerType?.iconUrl,
        name: markerType?.name || "Unknown",
        vectorIconUrl: markerType.vectorIconUrl,
        usageFlag: markerTypeId,
      },
      public: false,
    };

    setLoadSpinner(true)

    if (editable) {
      toSave.id = editable.id

      // console.log(toSave, '==============>toSave')
      // console.log(markerType, '=============>markerType')

      try {
        const res = await props.markerThreeDUpdateRequest(toSave);
        if (markerRef.current) {
          // console.log('=---yeru------------')
          markerRef.current.remove();
          markerRef.current = null;
        }
        props.collapseLeftToolbar();
        setLoadSpinner(false)

      } catch (err) {
        console.error("Could not save marker", err);
        props.collapseLeftToolbar();
        setLoadSpinner(false)
      }
    }
    else {
      try {
        const res = await props.markerCreateRequest(toSave);
        props.collapseLeftToolbar();
        setLoadSpinner(false)

      } catch (err) {
        console.error("Could not save marker", err);
        props.collapseLeftToolbar();
        setLoadSpinner(false)
      }
    }

  };

  const dropdownHeight = openStyleIcon ? 400 : 0;

  return (
    <>
      {loadSpinner &&
        <div className='markers-load-spinner'>
          <div className="loader-spinner"></div>
        </div>
      }

      <div style={{ position: 'relative' }}>
        <GetHeader
          collapseLeftToolbar={() => props.collapseLeftToolbar()}
          title={props.leftToolbarState.editable ? 'Edit' : 'Add'}
          titleName={props.type == 'huntStand' ? 'Stand' : 'Marker'}
          absolute={true}
          marginTop={5}
        ></GetHeader>
        {locationSet
          ? <Lock onClick={startMoveMode}
              style={{ position: 'absolute', right: 8, top: 74, fontSize: 22, color: '#aaa', cursor: 'pointer' }} />
          : <LockOpen onClick={stopMoveMode}
              style={{ position: 'absolute', right: 8, top: 74, fontSize: 22, color: '#589500', cursor: 'pointer' }} />
        }
      </div>

      <div className="tools-content">

        <div className="container-box">
          <div className="container-box-two" style={{ overflowY: "scroll", height: "calc(100vh - 145px)" }}>
            <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='name' width='92%' containerWidth='100%' access='false' displayVal={state.name}    ></MakeTextInput  >

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}>
              <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='latitude' width='85%' access='false' displayVal={state.latitude} latVal={state.latitude} lngVal={state.longitude}  ></MakeTextInput  >
              <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='longitude' width='85%' access='false' displayVal={state.longitude} latVal={state.latitude} lngVal={state.longitude} marginLeft='10' ></MakeTextInput  >
            </div>

            <NewMarkerIconStyle
              dropdownHeight={dropdownHeight}
              iconProp={iconUrl}
              markerGroups={props.markerGroups}
              type={props.leftToolbarState?.editable?.markerType?.usageFlag == 3 ? 'addStand' : ''}
              typeOfProp={props.typeOfProp}
              leftToolbarState={props.leftToolbarState}
              recentUsedMarkers={props.recentUsedMarkers}
              selectedStyle={selectedStyle}
              colorMarker={colorMarker}
              markerTypeId={markerTypeId}
              locationName={locationName}
              openStyleIcon={openStyleIcon}
              setOpenStyleIcon={setOpenStyleIcon}
              setSelectedStyle={setSelectedStyle}
              setFilterItems={setFilterItems}
              selectColor={(val) => {
                rebuild(val, markerTypeId)
                setColorMarker(val)
              }}
              editable={props.leftToolbarState.editable}
              setIconUrl={(value) => { iconUrlRef.current = value; setIconUrl(value) }}
              selectAnimal={(value) => {
                iconUrlRef.current = value.vectorIconUrl
                rebuild(colorMarker, value.id)
                setmarkerType(value)
                setMarkerTypeId(value.id)
                setLocationName(value.name)
              }}
            />

            <div style={{ position: "relative", top: 0, marginBottom: 20 }}>
              <div></div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                top: 0,
                marginBottom: 20,
              }}
            >
              <label
                htmlFor="notes"
                className="label-style"
                style={{ marginBottom: 10 }}
              >
                Notes:
              </label>
              <textarea
                name="notes"
                id="notes"
                className="marker-notes"
                style={{
                  height: "150px",
                  background: "#333333 0% 0% no-repeat padding-box",
                  borderRadius: 5,
                  opacity: 1,
                  border: "none",
                  width: "99%",
                }}
                onChange={handleInputChange}
              ></textarea>
            </div>

            {editable && editable.weatherObservation &&
              <div style={{
                position: 'relative',
                // , top: dropdownHeight,
                marginBottom: 20
              }}>
                <label htmlFor='notes'
                  className='label-style'
                  style={{ marginBottom: 10 }}>SmartMarker&#8482; Data:
                </label>
                <div className='marker-weather-container'>
                  <div style={{ width: '100%', height: '100%' }}>
                    <div className='weather-data-header' >
                      <p style={{}}>Weather Data</p>
                    </div>
                    <div className='weather-data-value' >
                      <div style={{ display: 'flex' }}>
                        <h1>{`${props.userPreferences.units == "imperial" ? editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.tempF : Math.round((editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.tempF - 32) / 1.8)}\u00B0`}</h1><p>{props.userPreferences.units == "imperial" ? 'F' : 'C'}</p>
                        <img src={editable && editable.weatherObservation && (editable.weatherObservation.weatherObservation.baseIconUrl + editable.weatherObservation.weatherObservation.weatherIcon)}
                          style={{ width: 20, height: 20, marginLeft: 20 }}
                        ></img>
                        <p style={{ marginLeft: 5, marginTop: 2 }}>{editable && editable.weatherObservation && editable.weatherObservation.weatherObservation.weatherPrimary}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div
          style={{
            width: "95%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            position: "relative",
            bottom: 0,
            margin: 0,
            padding: 10,
            top: 10,
          }}
        >
          <button style={{ width: "40%", margin: 0, backgroundColor: "grey" }} onClick={() => props.collapseLeftToolbar()} >
            Cancel
          </button>
          <button style={{ width: "40%", margin: 0, backgroundColor: "#589500" }} onClick={() => saveMarker()}>
            Save Changes
          </button>
        </div>

        <div className="confirm-removal-popup"></div>
        <div className="discard-popup"></div>
      </div >
    </>
  )
}

const mapStateToProps = state => ({
  mapReferenceThreed: state.mapReferenceThreed,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  token: state.auth.token,
  leftToolbarState: state.leftToolbarState,
  // mapReference: state.mapReference(),
  markerGroups: state.markerGroups,
  markerTypes25: state.markerTypes25,
  markerTypes35: state.markerTypes35,
  markerTypes105: state.markerTypes105,
  user: state.user,
  disableMapObj: state.disableMapObj,
  userPreferences: state.userPreferences,
  markerCenter: state.markerCenter,
  vendors: state.vendors,
  auth: state.auth,
  infoWindow: state.infoWindow,
  markers: state.markers.filter(marker => marker &&
    marker.markerType.usageFlag != 3),
  huntStands: state.markers.filter(marker => (marker && marker.markerType.usageFlag == 3))
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  markerCreateRequest: (payload) => dispatch(markerCreateRequest(payload)),
  markerThreeDUpdateRequest: (payload) => dispatch(markerThreeDUpdateRequest(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(ThreeDMarkerDetails)

